/** Dados do navegador e da página que acompanham todo feedback. */

export function collectEnvironment() {
  return {
    user_agent: navigator.userAgent.slice(0, 500),
    language: navigator.language ?? null,
    viewport_width: window.innerWidth,
    viewport_height: window.innerHeight,
    screen_width: window.screen?.width ?? null,
    screen_height: window.screen?.height ?? null,
    device_pixel_ratio: window.devicePixelRatio ?? null,
  };
}

export function collectPage() {
  return {
    url: window.location.href.slice(0, 2000),
    pathname: window.location.pathname.slice(0, 500),
    title: document.title.slice(0, 300) || null,
    referrer: document.referrer ? document.referrer.slice(0, 2000) : null,
  };
}
